var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.53 8.27C17.46 8.26 17.39 8.26 17.32 8.27C15.77 8.22 14.54 6.95 14.54 5.39C14.54 3.8 15.83 2.5 17.43 2.5C19.02 2.5 20.32 3.79 20.32 5.39C20.31 6.95 19.08 8.22 17.53 8.27Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.79 15.2C19.67 15.95 18.1 16.23 16.65 16.04C17.03 15.22 17.23 14.31 17.24 13.35C17.24 12.35 17.02 11.4 16.6 10.57C18.08 10.37 19.65 10.65 20.78 11.4C22.36 12.44 22.36 14.15 20.79 15.2Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.44002 8.27C6.51002 8.26 6.58002 8.26 6.65002 8.27C8.20002 8.22 9.43002 6.95 9.43002 5.39C9.43002 3.8 8.14002 2.5 6.54002 2.5C4.95002 2.5 3.65002 3.79 3.65002 5.39C3.66002 6.95 4.89002 8.22 6.44002 8.27Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.54999 13.35C6.54999 14.32 6.75999 15.24 7.13999 16.07C5.72999 16.22 4.26 15.92 3.18 15.21C1.6 14.16 1.6 12.45 3.18 11.4C4.25 10.68 5.75999 10.39 7.18 10.55C6.77 11.39 6.54999 12.34 6.54999 13.35Z",
    fill: "#424242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 16.37C12.04 16.36 11.9501 16.36 11.8601 16.37C10.0201 16.31 8.55005 14.8 8.55005 12.94C8.55005 11.04 10.0801 9.5 11.9901 9.5C13.8901 9.5 15.43 11.04 15.43 12.94C15.43 14.8 13.97 16.31 12.12 16.37Z",
    fill: "#424242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87005 18.44C7.36005 19.45 7.36005 21.11 8.87005 22.11C10.59 23.26 13.4101 23.26 15.1301 22.11C16.6401 21.1 16.6401 19.44 15.1301 18.44C13.4201 17.29 10.6 17.29 8.87005 18.44Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.a8044f864d54e72ab3d04adc6cd2ac3e.svg";
export { ForwardRef as ReactComponent };